import {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {Form} from "antd";
import {getMicroQualificationById} from "../../../../../../store/slices/MicroqualificationSaveSlice";

export const useMicroQualificationData = (id) => {
    const dispatch = useDispatch();
    const {data, isLoading, error} = useSelector(state => state.microQualification);
    const [form] = Form.useForm();
    const [isLoadingData, setIsLoadingData] = useState(false);

    useEffect(() => {
        dispatch(getMicroQualificationById({id}));
    }, [id, dispatch]);

    useEffect(() => {
        if (data) {
            setIsLoadingData(true);

            form.setFieldsValue({
                // Первый шаг - данные из firstStep
                creditNum: data.firstStep?.creditNumbers,
                licenceNumber: data.firstStep?.licenceNumber || "KZ67LAA00019559",
                levelOfNQF: data.firstStep?.levelOfNQF,
                learnLanguages: data.firstStep?.learnLanguage?.nameRu
                    ? data.firstStep.learnLanguage.nameRu.split(', ')
                    : [],
                professionalStandards: data.firstStep?.professionalStandards?.map(ps => ps.id) || [],

                // Второй шаг - данные из secondStep
                educationField: data.secondStep?.educationFieldId,
                trainingDirection: data.secondStep?.trainingDirectionId,
                groupEP: data.secondStep?.groupEPId,
                partnerOrg: data.secondStep?.partnerOrgId,
                mainDirectionRu: data.secondStep?.mainDirection?.nameRu,
                mainDirectionKz: data.secondStep?.mainDirection?.nameKz,
                mainDirectionEng: data.secondStep?.mainDirection?.nameEng,
                goalEng: data.secondStep?.goal?.nameEng,
                goalKz: data.secondStep?.goal?.nameKz,
                goalRu: data.secondStep?.goal?.nameRu,

                // Задачи - из массива tasks
                opTasks: data.tasks?.map(t => ({
                    nameRu: t.name?.nameRu,
                    nameKz: t.name?.nameKz,
                    nameEng: t.name?.nameEng
                })) || [],

                // Компетенции - из массива competences
                opDescOfCandORu: data.competences?.descOfCompetenceAndOutcomes?.nameRu,
                opDescOfCandOKz: data.competences?.descOfCompetenceAndOutcomes?.nameKz,
                opDescOfCandOEng: data.competences?.descOfCompetenceAndOutcomes?.nameEng,
                opCompetences: data.competences?.list
                    ? [...data.competences.list]
                        .sort((a, b) => a.name?.number - b.name?.number)
                        .map(comp => ({
                            nameRu: comp.name?.nameRu,
                            nameKz: comp.name?.nameKz,
                            nameEng: comp.name?.nameEng
                        })) : [],

                // Результаты обучения - из массива results
                opResults: data.results
                    ? [...data.results]
                        .sort((a, b) => a.name?.number - b.name?.number)
                        .map(result => ({
                            nameRu: result.name?.nameRu,
                            nameKz: result.name?.nameKz,
                            nameEng: result.name?.nameEng
                        })) : [],

                // Дисциплины - из массива disciplines
                opDisciplines: data.disciplines?.map(discipline => ({
                    nameRu: discipline.name?.nameRu,
                    nameKz: discipline.name?.nameKz,
                    nameEng: discipline.name?.nameEng,
                    descriptionRu: discipline.description?.nameRu,
                    descriptionKz: discipline.description?.nameKz,
                    descriptionEng: discipline.description?.nameEng,
                    creditNumbers: discipline.creditNumbers,
                    academicHours: discipline.academicHours,
                    code: discipline.code,
                    controlForm: discipline.controlForm,
                    competenceIds: discipline.competences?.map(comp => comp.id) || []
                })) || [],

                // Авторы - если есть в данных
                opAuthors: data.authors?.map(author => ({
                    id: author.id,
                    firstName: author.firstName,
                    middleName: author.middleName,
                    lastName: author.lastName,
                    firstNameEng: author.firstNameInEnglish,
                    lastNameEng: author.lastNameInEnglish,
                    positionRu: author.position?.nameRu,
                    positionKz: author.position?.nameKz,
                    positionEng: author.position?.nameEng,
                    workPlaceRu: author.workPlace?.nameRu,
                    workPlaceKz: author.workPlace?.nameKz,
                    workPlaceEng: author.workPlace?.nameEng,
                    isApprover: author.isApprover
                })) || []
            });

            setIsLoadingData(false);
        }
    }, [data, form]);

    return {
        data,
        isLoading: isLoading || isLoadingData,
        error,
        form
    };
};
